import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import Dividendes from "components/app/AuditComplet/SituationPro/Dividendes";
import { AppContext } from "components/app/RemExprertProvider";
import Pager from "components/ui/controls/pager/pager";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import React, { useContext, useState } from "react";
import { FaGlobe, FaMoneyBillWave, FaChartLine, FaBuilding, FaPiggyBank, FaUsers, FaDollarSign } from "react-icons/fa";
import CompactFinancialCard, { CompactFinancialContainer, FINANCIAL_THEMES } from "./CompactFinancialCard";

function RemExpressResAvtIS(props) {
  const { Periode,ClientConjoint } = props;
  const [modalResultatEntreprise, setmodalResultatEntreprise] = useState(false);
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);

  return (
    <>
   
    <CompactFinancialContainer
      title="Résultat avant IS"
      subtitle="Analyse financière de l'entreprise"
    >      <CompactFinancialCard
        icon={<FaChartLine />}
        title="Résultat avant IS"
        value={context.state.RemExpressResAvtIs}
        isEditable={true}
        onChange={(e) => context.handleCalculRemExpress("res_avant_is", "RemExpressResAvtIs", ResultatTNS, e)}
        theme={FINANCIAL_THEMES.success}
      />

      <CompactFinancialCard
        icon={<FaBuilding />}
        title="Impôt sur les sociétés"
        value={applyFormat(context.state.RemExpressImpotSoc, "uint", { thousands: " ", decimal: ",", unit: " €" })}
        onEdit={() => setmodalResultatEntreprise(true)}
        theme={FINANCIAL_THEMES.danger}
      />

      <CompactFinancialCard
        icon={<FaPiggyBank />}
        title="Mise en réserve"
        value={applyFormat(Number(context.state.RemExpressReserve), "uint", { thousands: " ", decimal: ",", unit: " €" })}
        theme={FINANCIAL_THEMES.purple}
      />

      <CompactFinancialCard
        icon={<FaUsers />}
        title="Dividendes autres associés"
        value={applyFormat(Number(context.state.RemExpressDivAutres), "uint", { thousands: " ", decimal: ",", unit: " €" })}
        theme={FINANCIAL_THEMES.purple}
      />

      <CompactFinancialCard
        icon={<FaDollarSign />}
        title="Dividendes bruts"
        value={context.state.RemExpressDividendeBrut}
        isEditable={true}
        onChange={(e) => context.handleCalculRemExpress("dividende_brut", "RemExpressDividendeBrut", ResultatTNS, e)}
        theme={FINANCIAL_THEMES.primary}
      />
    </CompactFinancialContainer>
    
      <Modal
        width="80%"
        height="82%"
        title="Situation professionnelle"
        icon={<FaGlobe />}
        visible={modalResultatEntreprise}
        onClose={() => {
          setmodalResultatEntreprise(false);
        }}
      >
       <Pager
        pages={[
          {
            label: "Dividendes",
            icon: <FaMoneyBillWave />,
            content: <Dividendes Outil={"RemExpress"} ClientConjoint="" />,
          },
        ]}
        page={0}
        navButtons={{
          validate: {
            onClick: (evt) => {
              context.handleCalculRemExpress('dividende_brut',"", ResultatTNS, "");
              setmodalResultatEntreprise(false);
            },
          },
        }}        />
      </Modal>
       </>
  );
}
export default RemExpressResAvtIS;
